import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Footer Component.
 */
export class FooterComponent implements OnInit
{
	/**
	 * Languages.
	 */
	public languages: any[];

	/**
	 * Constructor.
	 */
	public constructor(
		private translateService: TranslateService
	)
	{}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		// Languages.
		this.languages = this.translateService.getLangs();
	}

	/**
	 * Sets the language.
	 */
	public setLanguage(language: string)
	{
		this.translateService.use(language);
	}

	/**
	 * Checks if a language is the current language.
	 */
	public isActiveLanguage(language: string): boolean
	{
		return (this.translateService.currentLang == language);
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/footer/footer.component.ts